export const DEFAULT_OG_IMAGE={path:'/images/og-default-v2.png',width:2400,height:1260,alt:'Just Salad'};